import React from 'react';
import PropTypes from 'prop-types';
import { intlShape } from '../../../util/reactIntl';
import css from './Sections.module.css';
import { Icons } from '../../../components';
import classNames from 'classnames';

function SectionFeatures({ intl }) {
  const featureItems = [
    {
      icon: 'zeroSellingFees',
      title: intl.formatMessage({ id: 'HowItWorksPage.SectionFeatures.zeroSellingFees.title' }),
      description: intl.formatMessage({ id: 'HowItWorksPage.SectionFeatures.zeroSellingFees.description' }),
    },
    {
      icon: 'protectedPayment',
      title: intl.formatMessage({ id: 'HowItWorksPage.SectionFeatures.protectedPayments.title' }),
      description: intl.formatMessage({ id: 'HowItWorksPage.SectionFeatures.protectedPayments.description' }),
    },
    {
      icon: 'regionalMarketplace',
      title: intl.formatMessage({ id: 'HowItWorksPage.SectionFeatures.regionalMarketplace.title' }),
      description: intl.formatMessage({ id: 'HowItWorksPage.SectionFeatures.regionalMarketplace.description' }),
    },
    {
      icon: 'controlPricing',
      title: intl.formatMessage({ id: 'HowItWorksPage.SectionFeatures.controlPricing.title' }),
      description: intl.formatMessage({ id: 'HowItWorksPage.SectionFeatures.controlPricing.description' }),
    },
    {
      icon: 'vettedDaily',
      title: intl.formatMessage({ id: 'HowItWorksPage.SectionFeatures.vettedDaily.title' }),
      description: intl.formatMessage({ id: 'HowItWorksPage.SectionFeatures.vettedDaily.description' }),
    },
    {
      icon: 'disputeProtection',
      title: intl.formatMessage({ id: 'HowItWorksPage.SectionFeatures.disputeProtection.title' }),
      description: intl.formatMessage({ id: 'HowItWorksPage.SectionFeatures.disputeProtection.description' }),
    },
  ];
  return (
    <div className={css.featuresContainer}>
      <div className={css.fixedWidthContainer}>
        <div className={css.featuresTabs}>
          <span className={classNames(css.tab, css.active)}>
            {intl.formatMessage({ id: 'HowItWorksPage.SectionFeatures.tabSellers' })}
          </span>
          <span className={css.tab}>
            {intl.formatMessage({ id: 'HowItWorksPage.SectionFeatures.tabBuyers' })}
          </span>
          <span className={css.tab}>
            {intl.formatMessage({ id: 'HowItWorksPage.SectionFeatures.tabBuyerProtection' })}
          </span>
        </div>
        <div className={css.featuresContent}>
          {featureItems.map(({ title, description, icon }, index) => (
            <div key={index} className={css.categoryItem}>
              <Icons name={icon} />
              <h3>{title}</h3>
              <p>{description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

SectionFeatures.propTypes = {
  intl: intlShape.isRequired,
};

export default SectionFeatures;